<template>
	<div id="linkBuilding">
		<Loading v-if="loading" :text="'Atualizando'"></Loading>
		<dashboardMenu @updateCategories="[]" />

		<alertConfirmAction
			v-if="toggleAlertConfirmAction"
			:confirmText="'Excluir'"
			@confirmAction="removeUrl"
			@cancelAction="cancelRemoveUrl"
		>
			<h5 slot="title">Excluir link?</h5>
			<p slot="text">Deseja realmente remover este conteúdo?</p>
		</alertConfirmAction>
		<div v-if="showMediaManager == 'background' " class="media--manager">
			<div class="nav-mediaManager p-4">
				<i
					class="fas fa-chevron-down"
					@click="showMediaManager = false"
				></i>
			</div>
			<MediaManager @closeTabs="closeTabs()" @receiveMedias="addPicture($event,'background')" :maxUploadFiles="1" :maxImagesSelected="1"/>
		</div>
		<div v-else-if="showMediaManager == 'logo'" class="media--manager">
			<div class="nav-mediaManager p-4">
				<i
					class="fas fa-chevron-down"
					@click="showMediaManager = false"
				></i>
			</div>
			<MediaManager @closeTabs="closeTabs()" @receiveMedias="addPicture($event,'logo')" :maxUploadFiles="1" :maxImagesSelected="1"/>
		</div>
		<div v-else-if="showMediaManager == 'avatar'" class="media--manager">
			<div class="nav-mediaManager p-4">
				<i
					class="fas fa-chevron-down"
					@click="showMediaManager = false"
				></i>
			</div>
		<MediaManager @closeTabs="closeTabs()" @receiveMedias="addPicture($event,'avatar')" :maxUploadFiles="1" :maxImagesSelected="1"/>
		</div>
		<div class="container pt-5">
			<div class="d-flex justify-content-around">
					<div :class="'box-background text-center'" >
							<span>Imagem de fundo</span>
							<FileAdd v-if="!page.background_file" type="big" style="min-height: 100px" @mediaclick="openMediaManager('background')" />
							<div v-else :style="{display: 'flex', justifyContent: 'center'}">
							<div  :style="{display: 'flex', justifyContent: 'end'}">
								<button  class="bg-button"  @click="openMediaManager('background')">
									<BaseImage
									:customClass="'thumb'"
									:source="page.background_file"
									:fitIn="'300x0'"
								/>
							</button>
								<span
									class="control-buttons"
									v-if="true"
									@click="removeContainer()"
								>
									<i class="fal fa-trash-alt"></i>
								</span>
								</div>
							</div>
					</div>
				<div class="d-flex flex-column">
						<div>
							<h3 class="mb-2">Link Building</h3>
						</div>
						<div class="mb-0">
							<a :href="mainDomain + '/links'" target="_blank">{{ mainDomain|removeHttps }}/links</a>
						</div>
						<div class="mb-4">
							<div class="showUrl" v-if="!showEditRoute">
								<a :href="'https://' + page.app_short_domain + '/' + page.route" target="_blank">{{ page.app_short_domain|removeHttps }}/{{ page.route }}</a>
								<i class="fal fa-pen cursor-pointer p-2" @click="showEditRoute = !showEditRoute"></i>
							</div>
							<div class="editUrl" v-else style="line-height: 2.5rem;">
								<span class="float-left">https://{{ page.app_short_domain }}/</span>
								<input type="text" v-model="page.route" class="form-control float-left" style="max-width: 150px;">
								<span class="cursor-pointer" @click="editShortUrl()">Salvar</span>
							</div>
							<span v-if="msgErrorLink != ''" class="error-short_route">{{ msgErrorLink }}</span>
						</div>
				</div>
			</div>
			<div class="row mb-4 max-600">
				<div class="col-12 align-items-center justify-content-center mb-3" >
					<div class="text-center">
						<label>Exibir</label>
						<select v-model="page.logo_type" @change="updateForm()">
							<option value="1">Logo</option>
							<option value="2">Avatar arredondado</option>
						</select>
					</div>
					<div :class="'box-logo box-logo-type-' + page.logo_type">
						<div :class="'logoType'" v-if="page.logo && page.logo_type == 1">
							<BaseImage
								:customClass="'img-galery'"
								:source="page.logo"
								:fitIn="'300x0'"
							/>
							<input
								type="file"
								class="d-none"
								ref="uploadLogo"
								@change="handleFile('uploadLogo', 'logo')"
							/>
							<FileAdd
								type="icon"
								@mediaclick="openMediaManager('logo')"
							/>
						</div>
						<div :class="'logoType'" v-else-if="page.avatar && page.logo_type == 2">
							<BaseImage
								:customClass="'img-galery'"
								:source="page.avatar "
								:fitIn="'300x0'"
							/>
							<input
								type="file"
								class="d-none"
								ref="uploadAvatar"
								@change="handleFile('uploadAvatar', 'avatar')"
							/>
							<FileAdd
								type="icon"
								@mediaclick="openMediaManager('avatar')"
							/>
						</div>
						<div v-else-if="page.logo_type==2">
							<FileAdd type="big" @mediaclick="openMediaManager('avatar')"/>
							<input
								type="file"
								class="d-none"
								ref="uploadAvatar"
								@change="handleFile('uploadAvatar', 'avatar')"
							/>
						</div>
						<div v-else>
							<FileAdd type="big" @mediaclick="openMediaManager('logo')"/>
							<input
								type="file"
								class="d-none"
								ref="uploadLogo"
								@change="handleFile('uploadLogo', 'logo')"
							/>
						</div>
					</div>

				</div>
				<div class="col-12 mb-3">
					<label>Título</label>
					<input type="text" v-model="page.name" class="form-control" @blur="updateForm()">
				</div>
				<div class="col-12 mb-3">
					<label>Descrição</label>
					<textarea v-model="page.description" rows="1" class="form-control" @blur="updateForm()" ></textarea>
				</div>
			</div>
			<div v-if="linksBuilding.length == 0">
				<p>
					Você ainda não possui nenhum link cadastrado
				</p>
			</div>
			<div class="row" v-else>
				<draggable
					:force-fallback="true"
					v-model="linksBuilding"
					handle=".draggable"
					draggable=".draggable"
					@start="drag=true"
					@end="drag=false"
					class="w-100"
				>
					<transition-group>
						<div
							class="col-12 mb-3 draggable"
							v-for="(item, index) in linksBuilding"
							:key="item.id"
							:id="item.id"
						>
							<div class="card card-body">
								<div class="d-flex align-items-center justify-content-between">
									<div class="d-flex align-items-center cursor-pointer overflow">
										<i class="fas fa-bars mr-3"></i>
										<h5 class="float-left m-0 overflow">{{ item.route_name }}</h5>
									</div>
									<div class="d-flex">
										<div
											class="item-settings-button"
										>
											<span
												@click="handleEditUrl(index)"
											>
												<i class="fal fa-pencil-alt"></i>
											</span>
											</div>
										<div
											class="item-settings-button"
										>
											<span
												@click="handleRemoveUrl(index)"
											>
												<i class="fal fa-trash-alt"></i>
										</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</transition-group>
				</draggable>

			</div>
			<div v-if="!showMediaManager" class="pb-5 mb-5">
				<div class="position-fixed ps-b-4 ps-h-center to-front">
						<span
							class="pointer btn btn-primario py-2"
							@click="newLinkHandler"
						>
							<i class="fal fa-plus"></i> Novo link
						</span>
					</div>
			</div>

			<ModalLinkBuilding
				:title="title"
				@savingModal="saving = $event"
				:url="url"
				:linkModal="linkModal"
				@onClose="linkModal = $event"
				@linksBuilding="linksBuilding.push($event)"
				@updateForm="updateForm()"
				@clearModal="clearModal()"
			>
			</ModalLinkBuilding>


		</div>
	</div>
</template>

<script>
	import draggable from "vuedraggable";
	import axios from "axios";
	import Loading from "../Loading";
	import apiMixins from "@/mixins/apiMixins";
	import dashboardMenu from "@/components/DashboardMenu";
	import alertConfirmAction from "@/components/organisms/AlertConfirmAction";
	import ModalLinkBuilding from "@/components/organisms/ModalLinkBuilding";
	import FileAdd from "../molecules/FileAdd.vue";
	import BaseImage from "@/components/atoms/BaseImage";

	import MediaManager from "@/components/organisms/MediaManager";

	export default {
		name: "LinkBuilding",
		data() {
			return {
				showMediaManager: null,
				loading: false,
				showEditRoute: false,
				newNumber: "",
				toggleAlertConfirmAction: false,
				itemToRemove: null,
				saving: false,
				file: null,
				msgErrorLink: '',
				linksBuilding: [],
				mainDomain: this.$session.get("domain"),
				title:"",
				linkModal: false,
				page: {
					logo: "",
					avatar: "",
					name: "",
					logo_type: "",
					route: "",
					background_file: "",
					description: "",
				},
				url:{
					route_name: "",
					route_path: "",
					type: 7,
					target_blank: 1,
					typeRoute: "route",
					ddi: ""
				}
			};
		},
		mixins: [apiMixins],
		components: {
			Loading,
			dashboardMenu,
			alertConfirmAction,
			FileAdd,
			BaseImage,
			MediaManager,
			ModalLinkBuilding,
			draggable,
		},
		filters: {
			urlComplete(value) {
				return `${process.env.CDN_URL}${value}`;
			},
			removeHttps(value){
				if(value)
					return value.replace('https://', '');
				else
					return '';
			}
		},
		watch:{
			linksBuilding(){
				this.updateSortLink()
			}
		},
		methods: {
			closeTabs() {
				this.loadingUploadImage = false;
				this.showMediaManager = false;
			},
			clearModal(){
				this.url = {
					route_name: "",
					route_path: "",
					type: 7,
					target_blank: 1,
					typeRoute: "route",
					ddi: ""
				}
			},
			removeContainer(){
				this.page.background_file = null;
				this.updateForm();
			},
			openMediaManager(type) {
				this.showMediaManager = type;
			},
			addPicture(pictures,img) {
				var pic = pictures[0];
                pic = pic.url;
				if(img == 'background'){
					this.page.background_file = pic;
				}
				else if(img == 'logo'){
					this.page.logo = pic;
				}
				else if(img == 'avatar'){
					this.page.avatar = pic;
				}
				this.showMediaManager = null;
				this.updateForm();
			},
			async updateSortLink(){
				this.saving = true;
				const url = `/site/${this.$session.get("siteId")}/linkBuilding/sort`;
				const linksBuilding = { linksBuilding : this.linksBuilding}
				const statusRequest = await this.requestApiData(url, "post", linksBuilding);
				if (statusRequest.status == 1) {
					this.msgErrorLink = '';
					this.saving = false;
					return statusRequest;
				} else {
					alert("Erro ao atualizar status do anúncio");
					return statusRequest;
				}
			},
			async updateForm(){
				this.loading = true;
				const url = `/site/${this.$session.get("siteId")}/linkBuilding/updateForm`;
				const statusRequest = await this.requestApiData(url, "post", this.page);
				if (statusRequest.status == true) {
					window.location.reload();
				} else {
					alert("Erro ao atualizar status do anúncio");
					return statusRequest;
				}
			},
			async editShortUrl(){
				this.loading = true;
				var returnEdit = await this.updateForm();
				this.saving = false;
				if(returnEdit.status == true){
					this.loading = false;
					this.showEditRoute = false;
				}
				else{
					this.loading = false;
					this.msgErrorLink = returnEdit.message.message;
				}
			},
			handleRemoveUrl(index) {
				this.itemToRemove = index;
				this.toggleAlertConfirmAction = true;
			},
			async removeUrl() {
				const itemId = this.linksBuilding[this.itemToRemove].id;
				const url = `/site/${this.$session.get(
					"siteId"
				)}/linkBuilding/${itemId}/delete`;
				const statusRequest = await this.requestApiData(url, "post");
				if (statusRequest.status == true) {
					this.linksBuilding.splice(this.itemToRemove, 1);
				} else {
					alert("Erro ao remover url");
				}
				this.toggleAlertConfirmAction = false;
				this.itemToRemove = null;
			},
			cancelRemoveUrl() {
				this.itemToRemove = null;
				this.toggleAlertConfirmAction = false;

			},
			newLinkHandler() {
				this.url = {
					route_name: "",
					route_path: "",
					type: 7,
					target_blank: 1,
					typeRoute: "route",
					ddi: ""
				}
				this.title = 'Adicionar Link'
				this.linkModal = true
			},
			handleEditUrl(index) {
				this.title = 'Editar Link'
				this.url = this.linksBuilding[index]
				this.linkModal = true
			},
			handleFile(file, type) {
				var handle = this.$refs[file];
				let str = handle.files[0].name.toLowerCase().split(".");
				let ext = str[str.length - 1];
				if (
					ext == "jpeg" ||
					ext == "jpg" ||
					ext == "png" ||
					ext == "gif" ||
					ext == "svg"
				) {
					this.file = handle.files[0];
					this.uploadImage(type);
				} else {
					alert(
						"Arquivo " +
							this.$refs.uploadLogo.files[0].name +
							" não suportado. Selecione novamente"
					);
				}
			},
			uploadImage(type) {
				this.loading = true;
				this.message = "";
				let formData = new FormData();
				let token = this.$session.get("jwt");
				let file = this.file;
				let siteId = this.$session.get("siteId");
				formData.append("images[]", file);
				formData.append("siteId", this.siteId);
				axios({
					method: "post",
					url: `${process.env.ROOT_API}/api/site/${siteId}/image/upload`,
					data: formData,
					headers: {
						Authorization: "Bearer " + token,
						// 'Content-Type': 'application/x-www-form-urlencoded'
					},
				})
					.then((response) => {
						this.submitFile(type, response.data.file_source[0]);
					})
					.catch((response) => {
						console.log("Erro ao adicionar imagens");
					});
			},
			submitFile(type, filePath) {
				let formData = new FormData();
				let token = this.$session.get("jwt");
				formData.append("file", filePath);
				formData.append("type", type);
				axios({
					method: "post",
					url: process.env.ROOT_API + "api/site/" + this.$session.get("siteId") + "/linkBuilding/updateLogo",
					data: formData,
					headers: {
						Authorization: "Bearer " + token,
						// 'Content-Type': 'application/x-www-form-urlencoded'
					},
				})
					.then((response) => {
						this.message = response.data.message;
						if(type == 'logo'){
							this.page.logo = response.data.message.file;
							this.page.logo.path = response.data.message.file.path;
							this.page.logo_type = 1;
						}
						else{
							this.page.avatar = response.data.message.file;
							this.page.avatar.path = response.data.message.file.path;
							this.page.logo_type = 2;
						}

						this.loading = false;
					})
					.catch(function (e) {
						console.log(e);
						console.log("Falha ao atualizar logo do site");
						this.loading = false;
					});
			},

			getSiteLinkBuilding() {
				const siteId = this.$session.get("siteId");
				const token = this.$session.get("jwt");
				axios({
					method: "get",
					url: `${process.env.ROOT_API}api/site/${siteId}/linkBuilding`,
					headers: {
						Authorization: "Bearer " + token,
						// 'Content-Type': 'application/x-www-form-urlencoded'
					},
				}).then((response) => {
					if (response.data.status == true) {
						this.page = response.data.message.page;
						this.linksBuilding = response.data.message.linksBuilding;
					}
				});
			},
		},
		created() {

			this.$store.dispatch("VERIFY_TOKEN");
			//this.$store.dispatch("VERIFY_SITE");
			this.getSiteLinkBuilding();
		},
	};
</script>

<style type="text/css">
	.box-logo-type-2 .logoType .base-image{
		width: 96px !important;
	}

	.box-logo-type-2 img{
		overflow: hidden;
		width: 96px;
		height: 96px;
		object-fit: cover;
		object-position: center;
		border-radius: 50%;
	}
</style>

<style scoped>
	.overflow{
		overflow: hidden;
    white-space: normal;
	}
	.max-600{
		max-width: 600px;
		margin: 0 auto;
	}
	.box-logo{

	    width: 100%;
	    position: inherit;
	    margin: 0 auto;
	    display: block;
	    align-self: center;
	    position: relative;
	}
	.box-logo-type-1{
		max-width: 300px;
	}
	.box-logo-type-2{
		max-width: 300px;
	}

	.box-logo-type-2 .logoType{
		width: 96px;
	    height: 96px;
	    overflow: hidden;
	    margin: 0 auto;
	    border-radius: 50%;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	}
	.box-background{

	    width: 100%;
	    position: inherit;
	    margin: 0;
	    display: block;
	    align-self: center;
	    position: relative;
		max-width: 200px;
	}

	.bg-button{
		border: none;
		background-color: #fff;
	}

	.thumb{
		height: 100px;
		border-radius: 20px;
	}

	.add-image-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-color: white;
	}
	.add-image-container img {
		object-fit: cover;
	}
	.add-image-span {
		background-color: #f2f2f2;
		color: #858585;
		padding: 14px 39px;
		font-weight: 700;
	}
	.advertise-thumbnail {
		display: flex;
		width: 33%;
		min-height: 90px;
		padding: 0 10px;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #858585;
	}
	.advertise-data {
		font-size: 0.8rem;
		display: flex;
		flex-direction: column;
		width: 65%;
		min-height: 90px;
	}
	.remove-button {
		font-size: 1rem;
		color: #858585;
		transition: all 300ms;
	}
	.remove-button:hover {
		color: var(--error-color);
	}
	.toggle-off {
		color: #858585;
		transition: all 300ms;
	}

</style>
<style>
	.media--manager {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 50;
		background-color: #fff;
		overflow-y: auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/templates/LinkBuilding.vue